// extracted by mini-css-extract-plugin
export default {"link":"BackToTools_link__Buu4M"};